var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.snackBarStyles),attrs:{"id":_vm.id}},[_c('span',[_vm._v(_vm._s(_vm.message))]),_c('span',{staticClass:"hide",on:{"click":function($event){return _vm.hideSnackbar()}}},[_vm._v("Hide")])])
}
var staticRenderFns = []

export { render, staticRenderFns }